import {
  Component,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';

import * as fromWorkspace from 'src/store/workspace';
import * as fromRoot from 'src/store/index';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  TimeSheet,
  ClientDTO,
  TTMap,
  StaffDTO,
  Description,
  SearchDateOptions,
  Message,
  View,
  PTO
} from 'src/store/workspace';
import {
  Store
} from '@ngrx/store';
import {
  Observable,
  Subscription,
  combineLatest
} from 'rxjs';
import {
  GridComponent,
  RowClassArgs,
  PageChangeEvent,
  PagerSettings,
} from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import {
  environment
} from 'src/environments/environment';
import {
  cloneDeep
} from 'lodash';
import {
  ContextMenuComponent
} from '@progress/kendo-angular-menu';
import {
  SortDescriptor
} from '@progress/kendo-data-query';
import {
  isNumber
} from 'util';
import {
  TimePickerComponent
} from '@progress/kendo-angular-dateinputs';
import {
  getClass
} from '../alert/alert.component';
import { DropDownListComponent, PreventableEvent } from '@progress/kendo-angular-dropdowns';


@Component({
  selector: 'app-timesheet-detail',
  templateUrl: './timesheet-detail.component.html',
  styleUrls: ['./timesheet-detail.component.scss'],
})
export class TimesheetDetailComponent implements OnDestroy {
  staff$: Observable < StaffDTO > ;
  staff: StaffDTO;
  staffSubs: Subscription;

  searchStaff$: Observable < StaffDTO > ;
  searchStaffSubs: Subscription;
  searchStaff: StaffDTO;

  clients$: Observable < TTMap < ClientDTO >> ;
  clientsSubs: Subscription;
  clientsMap: TTMap < ClientDTO > ;
  clients: ClientDTO[];

  descriptions$: Observable < TTMap < TTMap < Description >>> ;
  descriptionSubs: Subscription;
  clientDescriptionsMap: TTMap < TTMap < Description >> ;
  descriptionsMap: TTMap < Description > ;
  descriptions: Description[];

  allSheets: TimeSheet[];
  gridData: TimeSheet[];

  editedRowIndex: number;
  formGroup: FormGroup;

  hours$: Observable < number > ;
  pageSize$: Observable < number > ;
  unsubmittedHours$: Observable < number > ;
  clientsCount$: Observable < number > ;

  dateOption$: Observable < SearchDateOptions > ;

  contextItem: {
    dataItem: TimeSheet,
    rowIndex: number
  };

  alert$: Observable < Message > ;
  getClass = getClass;

  @ViewChild('gridmenu', {
    static: false
  })
  public gridContextMenu: ContextMenuComponent;

  @ViewChild('grid', {
    static: false
  }) grid: GridComponent;

  public columns: any[] = [{
      field: 'staffName',
      title: 'Staff',
      width: 130
    },
    {
      field: 'timeSheetIdx',
      hidden: true
    },
    {
      field: 'timeSummaryIdx',
      hidden: true
    },
    {
      field: 'dateWorked',
      title: 'Date Worked',
      format: 'd',
      width: 130
    }, {
      field: 'startTime',
      title: 'Start Time',
      format: 't',
      width: 130
    }, {
      field: 'endTime',
      title: 'End Time',
      format: 't',
      width: 130
    }, {
      field: 'hoursBreak',
      title: 'Break',
      width: 100
    }, {
      field: 'hoursBillable',
      title: 'Billable',
      width: 100
    }, {
      field: 'clientName',
      title: 'Client Name',
      width: 200
    },
    {
      field: 'clientID',
      title: 'Client ID',
      hidden: true
    }, {
      field: 'billingDescription',
      title: 'Description of Service',
      width: 200
    }
  ];

  public gridData$: Observable < [fromWorkspace.TimeSheet[], number | 'all'] > ;
  public gridSubs: Subscription;
  public dialog: {
    action: 'edit' | 'delete',
    row: TimeSheet,
    index: number,
    opened: boolean
  };
  public multiple = true;
  public allowUnsort = true;
  public sort$: Observable < SortDescriptor[] > ;
  public sort: SortDescriptor[];
  public sortable = {
    allowUnsort: this.allowUnsort,
    mode: this.multiple ? 'multiple' : 'single'
  };

  public pageSize: number | 'all' = 'all';
  public skip = 0;
  public length: number;
  public pageable: PagerSettings = {
    pageSizes: true,
    previousNext: true,
    info: true
  };
  public pageSizes: any[] = [10, 20, 30, 40, 50, {
    text: 'All',
    value: 'all'
  }];

  constructor(private formBuilder: FormBuilder, private store: Store < fromRoot.AppState > , private cdr: ChangeDetectorRef) {
    this.dialog = {
      action: null,
      row: null,
      index: null,
      opened: false
    };
    this.alert$ = this.store.select(state => state.workspace.alert);
    this.staff$ = this.store.select(state => state.workspace.staff);
    this.staffSubs = this.staff$.subscribe(staff => this.staff = staff);
    this.clients$ = this.store.select(state => state.workspace.clients);
    this.clientsSubs = this.clients$.subscribe(clients => {
      this.clientsMap = clients;
      this.clients = Object.values(clients).sort((a, b) => {
        if (a.clientName.toLowerCase() > b.clientName.toLowerCase()) {
          return 1;
        }
        if (a.clientName.toLowerCase() < b.clientName.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    });

    this.descriptions$ = this.store.select(state => state.workspace.descriptions);
    this.descriptionSubs = this.descriptions$.subscribe(clientDescriptionMap => {
      this.clientDescriptionsMap = clientDescriptionMap;
    });
    this.gridData$ = combineLatest(
      this.store.select(fromWorkspace.selectTimesheetsForGrid),
      this.store.select(state => state.workspace.gridPageSize)
    );
    this.hours$ = this.store.select(state => state.workspace.totalHoursInSheet);
    this.unsubmittedHours$ = this.store.select(state => state.workspace.totalHoursUnsubmitted);

    this.clientsCount$ = this.store.select(state => state.workspace.numberOfClientsInSheet);

    this.dateOption$ = this.store.select(state => state.workspace.searchByOptions.dateOption);
    this.searchStaff$ = this.store.select(state => state.workspace.searchByOptions.staff);
    this.searchStaffSubs = this.searchStaff$.subscribe(staff => {
      this.searchStaff = staff;
      if (!staff || !staff.staffID) {
        this.columns[0].hidden = false;
      } else {
        this.columns[0].hidden = true;
      }
    });
    this.sort$ = this.store.select(state => state.workspace.detailSort);
    this.sort$.subscribe(sort => {
      this.sort = sort;
    });

    this.gridSubs = this.gridData$.subscribe(([sheets, pageSize]) => {
      if (this.grid && sheets.length !== this.allSheets.length) {
        this.closeEditor(this.grid);
      }
      this.length = sheets.length;
      this.pageSize = pageSize;
      if (!isNumber(pageSize)) {
        this.pageSize = this.length || 'all';
      }
      this.allSheets = sheets;
      const s = this.pageSize as number;
      this.gridData = sheets.slice(this.skip, this.skip + s);
    });
    this.store.dispatch(new fromWorkspace.LoadPageSize());
    this.store.select(state => state.workspace.gridPageSize).subscribe(size => {
      this.pageSize = size;
    });
  }

  public openOnFocus(list: DropDownListComponent) {
    list.toggle(!list.isOpen);
  }

  public mousedownHandler(e: MouseEvent) {
    e.preventDefault();
  }

  public disableClick(e: PreventableEvent) {
    e.preventDefault();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.store.dispatch(new fromWorkspace.SetSort({
      sort,
      view: View.detail
    }));
    this.store.dispatch(new fromWorkspace.LoadTimesheets());
  }

  public isEditing() {
    return this.grid && this.grid.isEditing() || (this.formGroup && this.formGroup.value && !(this.formGroup.value as TimeSheet).timeSheetIdx);
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    let pageSize: number | 'all' = event.take;
    if (pageSize === this.length) {
      pageSize = 'all';
    }
    this.store.dispatch(new fromWorkspace.SetPageSize(pageSize));
    this.store.dispatch(new fromWorkspace.LoadTimesheets());
  }

  openSubmitDialog(row: TimeSheet, action: 'edit' | 'delete', i: number) {
    this.dialog.row = row;
    this.dialog.opened = true;
    this.dialog.action = action;
    this.dialog.index = i;
  }

  submitDialog() {
    const sheet = this.dialog.row;
    if (this.dateIsFuture(this.dialog.row.dateWorked) && !this.isPTO(this.dialog.row)) {
      this.closeDialog();
      return this.store.dispatch(new fromWorkspace.SendMessage({
        type: 'warning',
        content: 'Your time entry cannot be future-dated'
      }));
    }

    if (this.sheetOverlaps(sheet)) {
      this.closeDialog();
      return this.store.dispatch(new fromWorkspace.SendMessage({
        type: 'warning',
        content: 'Your time entries overlap and cannot be saved'
      }));
    }

    if (sheet.hoursBillable <= 0) {
      this.closeDialog();
      return this.store.dispatch(new fromWorkspace.SendMessage({
        type: 'warning',
        content: 'Billable time has to be greater than zero.'
      }));
    }
    this.store.dispatch(new fromWorkspace.SetLoading(true));
    if (this.dialog.action === 'delete') {
      this.delete(this.dialog.row);
      return this.closeDialog();
    }
    this.store.dispatch(new fromWorkspace.UndoSummaryRow(this.dialog.row.timeSummaryIdx));
    this.save(this.dialog.index, this.formGroup);
    this.closeDialog();
  }

  closeDialog() {
    this.dialog.opened = false;
  }

  public submitCurrentPayPeriod() {
    this.store.dispatch(new fromWorkspace.SelectPayPeriod());
  }

  public submit() {
    this.store.dispatch(new fromWorkspace.SetLoading(true));
    this.store.dispatch(new fromWorkspace.SetView(View.summary));
    this.store.dispatch(new fromWorkspace.Search());
  }

  public normalizeDate(time: moment.Moment, offset ? : number) {
    const sheet = this.formGroup.value as TimeSheet;
    if (sheet.dateWorked) {
      const date = moment(sheet.dateWorked);
      time.date(date.date());
      time.month(date.month());
      time.year(date.year());
      if (offset) {
        time.add(offset, 'd');
      }
    }
    return time;
  }

  public roundToQuarter(field: string, timepicker: TimePickerComponent) {

    const sheet = this.formGroup.value as TimeSheet;
    const input = timepicker.input.inputValue;
    const date = this.formGroup.get('dateWorked').value as Date;

    if (input.includes('minute') && !input.includes('hour')) {
      let hour = Number(input.match(/(\d)/g).join(''));
      const period = input.match(/(AM|PM)/g).join('');
      if (period === 'PM' && hour !== 12) {
        hour += 12;
      }
      date.setHours(hour);
      date.setMinutes(0);
      date.setSeconds(0);
      sheet[field] = date;
    }

    this.dateWorkedChanged();

    if (!sheet[field]) {
      return;
    }
    let time = moment(sheet[field]);
    const minutes = time.clone().minute() || 0;
    let roundedMinutes = Math.round(minutes / 15) * 15;
    if (isNaN(roundedMinutes)) {
      roundedMinutes = 0;
    }
    time = time.minute(roundedMinutes).second(0);
    sheet[field] = time.toDate();
    this.formGroup.setValue(sheet);
    this.updateBillableHours();
    this.updateDay();
    if (field === 'startTime' && sheet[field] && !sheet.endTime) {
      this.setEndTime();
    }
  }

  public setEndTime() {
    const sheet = this.formGroup.value as TimeSheet;
    sheet.endTime = moment(sheet.startTime).add('15', 'm').toDate();
    this.formGroup.setValue(sheet);
  }

  public updateDay() {
    const sheet = this.formGroup.value as TimeSheet;
    if (!sheet.endTime || !sheet.startTime) {
      return;
    }
    const start = moment(sheet.startTime);
    const end = (moment(sheet.endTime));
    if (end.isBefore(start)) {
      const midnight =  start.startOf('day');
      if (end.isSame(midnight, 'minute')) {
        end.add(1, 'day');
        sheet.endTime = end.toDate();
        this.formGroup.setValue(sheet);
        return this.updateBillableHours();
      }
      return this.store.dispatch(new fromWorkspace.SendMessage({
        type: 'warning',
        content: 'Overnight time cannot be logged. Please open a new entry for the next day'
      }));
    }
  }

  public updateBillableHours() {
    const sheet = this.formGroup.value as TimeSheet;
    // round to nearest 0.25
    sheet.hoursBreak = Number((Math.round(sheet.hoursBreak * 4) / 4).toFixed(2));
    this.formGroup.setValue(sheet);
    const hours = this.getBillableHours(this.formGroup.value);
    this.formGroup.setValue({
      ...this.formGroup.value,
      hoursBillable: hours
    });
  }

  public ngOnDestroy() {
    this.gridSubs.unsubscribe();
  }

  public dateWorkedChanged() {
    const sheet = this.formGroup.value as TimeSheet;
    let dateWorked = moment(sheet.dateWorked);
    if (!dateWorked.isValid()) {
      dateWorked = moment();
      sheet.dateWorked = dateWorked.toDate();
    }
    const start = moment(sheet.startTime);
    const end = moment(sheet.endTime);

    start.set('date', dateWorked.date());
    start.set('month', dateWorked.month());
    start.set('year', dateWorked.year());
    sheet.startTime = start.toDate();

    if (!start.isValid()) {
      sheet.startTime = null;
    }
    end.set('date', dateWorked.date());
    end.set('month', dateWorked.month());
    end.set('year', dateWorked.year());
    sheet.endTime = end.toDate();

    if (!end.isValid()) {
      sheet.endTime = null;
    }
    // }
    this.formGroup.setValue(sheet);
  }

  public clientChanged(newClientID: number) {
    const sheet = this.formGroup.value as TimeSheet;
    const clientDescriptionsMap = this.clientDescriptionsMap[sheet.clientID];

    this.descriptions = [];

    if (clientDescriptionsMap) {
      this.descriptions = Object.values(clientDescriptionsMap);
      this.descriptions = this.descriptions.filter(d => d.active);
      this.descriptions = this.descriptions.sort((a, b) => {
        if (a.description.toLowerCase() > b.description.toLowerCase()) {
          return 1;
        }
        if (a.description.toLowerCase() < b.description.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    }

    this.descriptionsMap = this.clientDescriptionsMap[sheet.clientID];

    if (newClientID !== sheet.clientID) {
      sheet.billingDescription = null;
      sheet.descriptionOfService = null;
    }

    this.formGroup.setValue(sheet);
  }

  public addHandler({
    sender
  }) {
    this.closeEditor(sender);
    const today = new Date();
    let mostRecentSheetOnThisDay: TimeSheet;
    this.allSheets.forEach(sheet => {
      if (!moment(sheet.dateWorked).isSame(today, 'day')) {
        return;
      }
      if (!mostRecentSheetOnThisDay || moment(sheet.endTime).isAfter(mostRecentSheetOnThisDay.endTime)) {
        mostRecentSheetOnThisDay = sheet;
      }
    });
    const ts: TimeSheet = {
      timeSheetIdx: '',
      timeSummaryIdx: null,
      staffID: (this.searchStaff && this.searchStaff.staffID ? this.searchStaff.staffID : this.staff.staffID),
      dateWorked: today,
      startTime: mostRecentSheetOnThisDay ? mostRecentSheetOnThisDay.endTime : null,
      endTime: null,
      hoursWorked: 0.00,
      hoursBreak: 0.00,
      hoursBillable: 0.00,
      descriptionOfService: '',
      chargeToClient: null,
      clientID: null,
      billingDescription: null,
      deleted: false
    };
    this.formGroup = this.createFormGroup(ts);

    sender.addRow(this.formGroup);
  }

  public editHandler({
    sender,
    rowIndex,
    dataItem
  }) {
    this.closeEditor(sender);

    this.formGroup = this.createFormGroup(dataItem);

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);

    this.clientChanged(this.formGroup.get('clientID').value);
  }

  public cancelHandler({
    sender,
    rowIndex
  }) {
    this.closeEditor(sender, rowIndex);
  }

  public rowCallback(context: RowClassArgs) {
    if (context.dataItem.timeSummaryIdx) {
      if (context.index % 2) {
        return {
          'submitted-even': true
        };
      }
      return {
        submitted: true
      };
    }
  }

  dateIsFuture(e) {
    const date = moment(e);
    return date.isAfter(moment(), 'day');
  }

  sheetOverlaps(newSheet: TimeSheet) {
    const newStart = moment(newSheet.startTime, 'h:mma');
    const newEnd = moment(newSheet.endTime, 'h:mma');
    const newDate = moment(newSheet.dateWorked, 'M/d/y');
    for (const s of this.allSheets) {
      if (s.timeSheetIdx === newSheet.timeSheetIdx) {
        // we are editing an existing sheet. We do not want to compare it with itself.
        continue;
      }

      const start = moment(s.startTime, 'h:mma');
      const end = moment(s.endTime, 'h:mma');
      const date = moment(s.dateWorked, 'M/d/y');

      if (!newDate.isSame(date, 'day')) {
        continue;
      }

      if (newStart.isSame(start, 'minute')) {
        return true;
      }

      if (newStart.isAfter(start, 'minute') && newStart.isBefore(end, 'minute')) {
        return true;
      }

      if (newEnd.isBefore(end, 'minute') && newEnd.isAfter(start, 'minute')) {
        return true;
      }
    }
    return false;
  }

  public onCellClick({
    originalEvent,
    type,
    rowIndex,
    dataItem
  }): void {
    if (type === 'contextmenu') {
      originalEvent.preventDefault();
      this.contextItem = {
        dataItem,
        rowIndex
      };
      this.gridContextMenu.show({
        left: originalEvent.pageX,
        top: originalEvent.pageY
      });
    }
  }

  public contextMenuSelect({
    item,
    sender
  }) {
    if (item.text === 'Edit') {
      this.formGroup = this.createFormGroup(this.contextItem.dataItem);
      this.clientChanged(this.formGroup.get('clientID').value);
      return this.grid.editRow(this.contextItem.rowIndex, this.createFormGroup(this.contextItem.dataItem));
    }
    if (item.text === 'Delete') {
      return this.removeHandler(this.contextItem);
    }
    if (item.text === 'Duplicate') {
      return this.duplicate(this.contextItem.dataItem);
    }
    if (item.text === 'Clear Sort') {
      this.sort = [];
      this.store.dispatch(new fromWorkspace.SetSort({
        sort: this.sort,
        view: View.detail
      }));
    }
  }

  public duplicate(sheet: TimeSheet) {
    const dataItem = cloneDeep(sheet);
    dataItem.timeSheetIdx = null;
    dataItem.timeSummaryIdx = null;
    this.formGroup = this.createFormGroup(dataItem);
    this.grid.addRow(this.formGroup);
    this.clientChanged(dataItem.clientID);
  }

  public isPTO(sheet: TimeSheet) {
    return sheet.clientID === environment.tspClientID &&
      sheet.descriptionOfService.includes('W2');
  }

  public saveHandler({
    rowIndex,
    formGroup
  }): void {
    const sheet = formGroup.value as TimeSheet;
    if (sheet.timeSummaryIdx) {
      return this.openSubmitDialog(sheet, 'edit', rowIndex);
    }
    this.save(rowIndex, formGroup);
  }

  public clientHasCategorizedBilling(clientID: number, formGroup: FormGroup): boolean {
    const client = this.clients.find(c => c.clientID === clientID);
    return client && client.categorizeBilling;
  }

  public getDescriptionOfServiceFormControl() {
    const control = this.formGroup.get('billingDescription');
    if (!control.value && !control.dirty) {
      control.setValue(this.formGroup.get('descriptionOfService').value);
    }
    return control;
  }

  public save(rowIndex, formGroup) {
    const sheet = cloneDeep(formGroup.value) as TimeSheet;

    if (this.sheetOverlaps(sheet)) {
      this.grid.editRow(rowIndex, this.formGroup);
      return this.store.dispatch(new fromWorkspace.SendMessage({
        type: 'warning',
        content: 'Your time entries overlap and cannot be saved'
      }));
    }

    if (sheet.hoursBillable <= 0) {
      return this.store.dispatch(new fromWorkspace.SendMessage({
        type: 'warning',
        content: 'Billable time has to be greater than zero.'
      }));
    }

    if (isNumber(sheet.billingDescription)) {
      sheet.descriptionOfService = this.descriptionsMap[sheet.billingDescription].description;
    } else {
      sheet.descriptionOfService = String(sheet.billingDescription);
      sheet.billingDescription = null;
    }

    sheet.hoursBillable = this.getHoursWorked(sheet) - sheet.hoursBreak;

    if (this.dateIsFuture(sheet.dateWorked) && !this.isPTO(sheet)) {
      this.grid.editRow(rowIndex, this.formGroup);
      return this.store.dispatch(new fromWorkspace.SendMessage({
        type: 'warning',
        content: 'Your time entry cannot be future-dated'
      }));
    }
    const start = moment(sheet.startTime);
    const end = moment(sheet.endTime);
    let endOffset = 0;

    if (end.isAfter(start, 'd')) {
      endOffset = 1;
    }

    sheet.startTime = this.normalizeDate(start).toDate();
    sheet.endTime = this.normalizeDate(end, endOffset).toDate();

    this.store.dispatch(new fromWorkspace.SaveTimesheet(sheet));
    this.grid.closeRow(rowIndex);
  }

  public removeHandler({
    dataItem,
    rowIndex
  }): void {
      return this.openSubmitDialog(dataItem, 'delete', rowIndex);
  }
  public delete(dataItem: TimeSheet) {
    this.store.dispatch(new fromWorkspace.DeleteTimesheet(dataItem));
  }
  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  public createFormGroup(dataItem: TimeSheet): FormGroup {
    return this.formBuilder.group({
      timeSheetIdx: [dataItem.timeSheetIdx],
      timeSummaryIdx: [dataItem.timeSummaryIdx],
      dateWorked: [dataItem.dateWorked, Validators.required],
      startTime: [dataItem.startTime, Validators.required],
      endTime: [dataItem.endTime, Validators.required],
      hoursBreak: [dataItem.hoursBreak, Validators.compose([Validators.min(0), Validators.required])],
      clientID: [dataItem.clientID, Validators.required],
      hoursBillable: [dataItem.hoursBillable],
      chargeToClient: [dataItem.chargeToClient],
      deleted: false,
      staffId: [dataItem.staffID],
      billingDescription: [dataItem.billingDescription, Validators.required],
      descriptionOfService: [dataItem.descriptionOfService]
    });
  }

  public getHoursWorked(dataItem: TimeSheet): number {
    const start = moment(dataItem.startTime);
    const end = moment(dataItem.endTime);
    return moment.duration(end.diff(start)).asHours() || 0;
  }

  public getBillableHours(dataItem: TimeSheet): number {
    const hours = Number((this.getHoursWorked(dataItem) - dataItem.hoursBreak).toFixed(2));
    return hours;
  }
}
